import React from 'react';
import { AppUser } from '../../../types';
import { isCommercialProfile } from '../../../utils/commercialRoleHelper';
import { usePropertyComments } from '../../../hooks/usePropertyComments';

interface Props {
  propertyCode: string;
  appUser: AppUser | null;
}

export const PropertyDetailCommentShortcut: React.FC<Props> = ({ propertyCode, appUser }) => {
  const canAccess = isCommercialProfile(appUser?.role);
  const { comments, loading } = usePropertyComments(propertyCode, appUser);

  if (!canAccess || loading || comments.length === 0) {
    return null;
  }

  const handleScrollToComments = () => {
    const el = document.getElementById('property-comments-section');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <button
      type="button"
      onClick={handleScrollToComments}
      title="Haga clic para ver los comentarios comerciales al final"
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-teal-50 hover:bg-teal-100 border border-teal-200 text-teal-800 text-[11px] font-black uppercase tracking-tight shadow-xs transition-all active:scale-95 group cursor-pointer"
    >
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal-400 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-teal-600"></span>
      </span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        className="w-3.5 h-3.5 text-teal-600 group-hover:scale-110 transition-transform shrink-0"
      >
        <path
          fillRule="evenodd"
          d="M10 2c-4.418 0-8 3.134-8 7 0 1.76.732 3.376 1.968 4.614A8.17 8.17 0 0 1 3.1 16.892a.75.75 0 0 0 .97 1.026 10.15 10.15 0 0 0 3.864-1.854C8.618 16.275 9.294 16.4 10 16.4c4.418 0 8-3.134 8-7s-3.582-7-8-7Zm-3 6.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
          clipRule="evenodd"
        />
      </svg>
      <span className="hidden xs:inline sm:inline">Comentarios al final</span>
      <span className="px-1.5 py-0.2 rounded-full bg-teal-600 text-white text-[10px] font-black">
        {comments.length}
      </span>
      <span className="text-teal-600 font-bold ml-0.5 group-hover:translate-y-0.5 transition-transform">↓</span>
    </button>
  );
};
